module.exports = __webpack_public_path__ + "assets/img/239.png?05871ba423298199e89100d4b0f2da4c";